import { render, staticRenderFns } from "./CouponForm.vue?vue&type=template&id=e8e0229c&"
import script from "./CouponForm.vue?vue&type=script&lang=ts&"
export * from "./CouponForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports